<template>
  <v-row justify="center">
    <v-col cols="12" md="8" sm="8" class="px-10">
      <Iniciar ref="frmIniciar"></Iniciar>
    </v-col>
  </v-row>
</template>


<script>
import Iniciar from "../components/Login/Iniciar.vue";

export default {
  name: "Login",
  components: {
    Iniciar,
  },
  data: () => ({}),
  computed: {},
  methods: {},
};
</script>